<template>
  <div class="crypto-list">
      <div class="crypto-list-inner">

        <div class="crypto-list-animation-wrapper first">
            <div class="crypto-marquee" width="100%">
                <div v-for="(item , key) in list" :key="key" class="crypto-item-wrapper">
                  <div v-if="key < 10" class="crypto-item">
                    <div class="top">
                      <h3>{{item.symbol.replace('USDT' , '')}}</h3>
                      <img :src="'assets/images/icon/'+ item.symbol + '.png'" alt="">
                    </div>
                    <p class="font-en">$
                      <template v-if="item.markPrice > 100">{{ parseFloat(item.markPrice).toFixed(2) }}</template>
                      <template v-else-if="item.markPrice > 10">{{ parseFloat(item.markPrice).toFixed(3) }}</template>
                      <template v-else-if="item.markPrice > 1">{{ parseFloat(item.markPrice).toFixed(4) }}</template>
                      <template v-else-if="item.markPrice > 0.1">{{ parseFloat(item.markPrice).toFixed(5) }}</template>
                      <template v-else>{{ parseFloat(item.markPrice).toFixed(6) }}</template>
                    </p>
                  </div>
                </div>
            </div>
        </div>
        <div class="crypto-list-animation-wrapper second">
            <div class="crypto-marquee" width="100%">
                <div v-for="(item , key) in list" :key="key" class="crypto-item-wrapper">
                  <div v-if="key < 10" class="crypto-item">
                    <div class="top">
                      <h3>{{item.symbol.replace('USDT' , '')}}</h3>
                      <img :src="'assets/images/icon/'+ item.symbol + '.png'" alt="">
                    </div>
                    <p>{{formatPrice(parseInt(parseFloat(item.markPrice) * state_prices.sale_price))}} تومان</p>
                  </div>
                </div>
            </div>
        </div>

      </div>
  </div>
</template>
<script>
import crypto_currencies from '../plugins/crypto_currencies'
import {io} from 'socket.io-client';
export default {
  name:'CryptoCurrencies',
  data(){
    return{
      list:{},
      elements:{},
      crypto_currencies,
      socket:null,
      list_loaded:false,
    }
  },
  methods:{
    
    async getRealTimePrice (){
      await this.$axios.get(`getRealTimePrice?limit=20`)
      .then(res => {
        this.list = res.data.data
      })
      .catch(err => {
      });
    },
    getCryptoListWidth()
    {
      var elements = this.$el.querySelectorAll('.crypto-item');
      var width = 0
      for(var i = 0; i < elements.length; i++){
          width +=  elements[i].offsetWidth;
      }
      document.documentElement.style.setProperty('--cvari' , `${width}px`)
      document.documentElement.style.setProperty('--cvarisec' , `${width}s`)
    }
  },

  mounted(){

    const vm = this
    vm.socket = io(vm.socketUrl);
    vm.socket.emit('live_crypto_list');
    vm.socket.on('live_crypto_list', (data) => {
      vm.list = data
      vm.list_loaded = true
    });

  },

  updated(){
    this.getCryptoListWidth()

  }
}
</script>
<style>
.crypto-marquee{
  padding: 8px 0;
  display: flex;
  --cvari : 0px;
  --cvarisec : 0s;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.crypto-list {
  width: 100%;
  display: flex;
  opacity: 1 !important;
  background: #000000;
  position: relative;
  height: 120px;
  margin: 0;
  justify-content: center;
}
.crypto-list-inner {
  font-size: 16px;
  position: relative;
  overflow: hidden;
  align-items: center;
  white-space: nowrap;
  height: 100%;
}

.crypto-list-animation-wrapper.first {
  width: 100%;
  height: 100%;
  animation: infinite linear slide-first 20s;
  animation-delay: 10s;
}
.crypto-list-animation-wrapper.second {
  width: 100%;
  height: 100%;
  animation: infinite linear slide-second 20s;
  animation-delay: 10s;
}
.crypto-list-inner:hover .crypto-list-animation-wrapper {
    cursor: grabbing;
    animation-play-state: paused;
}
.crypto-item-wrapper {
    display: flex;
}
.crypto-list-animation-wrapper .crypto-item {
    padding: 0 18px;
    color: #fcfcfc;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 180px;
}
.crypto-list-animation-wrapper .crypto-item .top{
    display: flex;
    justify-content: center;
    align-items: center;
}
.crypto-list-animation-wrapper .crypto-item img{
    width: 45px;
    height: 45px;
    border-radius: 50%;
    margin: 0 0.5rem;
}
.crypto-list-animation-wrapper .crypto-item h3{
    margin-bottom: 0 !important;
    margin-top: 0 !important;
}
.crypto-list-animation-wrapper .crypto-item p{
    margin-bottom: 0 !important;
    margin-top: 0 !important;
}
@keyframes slide-first {
  0% {
    transform: translate(0 , 0);
    opacity: 1;
  }
  5% {
    transform: translate(0 , -100%);
    opacity: 1;
  }
  10% {
    transform: translate(0 , -100%);
    opacity: 0;
  }
  15% {
    opacity: 0;
    transform: translate(0 , 100%);
  }
  20% {
    transform: translate(0 , 100%);
    opacity: 1;
  }
  45% {
    transform: translate(0 , 100%);
    opacity: 1;
  }
  50% {
    opacity: 1;
    transform: translate(0 , 0);
  }
  100% {
    opacity: 1;
    transform: translate(0 , 0);
  }
}
@keyframes slide-second {
  0% {
    transform: translate(0 , 0);
    opacity: 1;
  }
  5% {
    transform: translate(0 , -100%);
    opacity: 1;
  }
  45% {
    opacity: 1;
    transform: translate(0 , -100%);
  }
  50% {
    opacity: 1;
    transform: translate(0 , -200%);
  }
  70% {
    transform: translate(0 , -200%);
    opacity: 0;
  }
  80% {
    transform: translate(0 , 0);
    opacity: 0;
  }
  90% {
    opacity: 1;
    transform: translate(0 , 0);
  }
  100% {
    opacity: 1;
    transform: translate(0 , 0);
  }
}
@media (max-width: 1800px) {
  .crypto-item-wrapper:nth-child(1){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(2){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(3){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(4){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(5){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(6){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(7){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(8){
    display: flex !important;
  }
  .crypto-item-wrapper{
    display: none;
  }
}
@media (max-width: 1440px) {
  .crypto-item-wrapper:nth-child(1){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(2){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(3){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(4){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(5){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(6){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(7){
    display: none !important;
  }
  .crypto-item-wrapper:nth-child(8){
    display: none !important;
  }
  .crypto-item-wrapper{
    display: none;
  }
}
@media (max-width: 1050px) {
  .crypto-item-wrapper:nth-child(1){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(2){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(3){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(4){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(5){
    display: none !important;
  }
  .crypto-item-wrapper:nth-child(6){
    display: none !important;
  }
  .crypto-item-wrapper{
    display: none;
  }
}
@media (max-width: 770px) {
  .crypto-item-wrapper:nth-child(1){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(2){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(3){
    display: flex !important;
  }
  .crypto-item-wrapper:nth-child(4){
    display: none !important;
  }
  .crypto-item-wrapper{
    display: none;
  }
  .crypto-list-animation-wrapper .crypto-item img {
    width: 35px;
    height: 35px;
  }
  .crypto-list-animation-wrapper .crypto-item {
    width: 130px;
  }
  .crypto-list-animation-wrapper .crypto-item h3 {
    font-size: 1.25rem;
  }
}
</style>